import { useTranslation } from 'react-i18next'
import { Spinner } from '@/components/ui/Spinner'

export function RouteFallback() {
  const { t } = useTranslation()

  return (
    <div className="flex min-h-dvh items-center justify-center p-6">
      <Spinner label={t('common.loading')} />
    </div>
  )
}
